import { render, staticRenderFns } from "./modal-tos-page-opt-in-2.vue?vue&type=template&id=a3d39862"
import script from "./modal-tos-page-opt-in-2.vue?vue&type=script&lang=js"
export * from "./modal-tos-page-opt-in-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports